import React from "react";
import { Button } from "../../../Atoms";
import { useNavigate } from 'react-router-dom';
import chargerImage from '../../../Assets/products_landing/Homecharger.png';

const evFeatures = [
    {
        id: 1,
        title: "Built-in safety",
        points: [
            "Overcurrent",
            "Overvoltage and undervoltage",
            "Ground fault",
            "Surge protection",
        ],
        position: "top-left",
    },
    {
        id: 2,
        title: "Dynamic Load management",
        points: [],
        position: "top-right",
    },
    {
        id: 3,
        title: "Connectivity",
        points: ["Ethernet RJ45", "WiFi", "GSM - 4G variants", "OCPP 1.6"],
        position: "bottom-left",
    },
    {
        id: 4,
        title: "Connectors",
        points: ["Bharat AC", "CSS2"],
        position: "bottom-right",
    },
];

const getPositionClasses = (position) => {
    switch (position) {
        case "top-left":
            return "top-4 left-4";
        case "top-right":
            return "top-4 right-4";
        case "bottom-left":
            return "bottom-4 left-4";
        case "bottom-right":
            return "bottom-4 right-4";
        default:
            return "";
    }
};
const FourSteps = () => {
    const navigate = useNavigate();
    return (
        <section className="bg-light-gradient-white blade-padding-sm">
            <div className="containers-min mx-auto px-4 py-12">
                <div className="2xl:pb-20 xl:pb-16 lg:pb-12 md:pb-8 pb-0">
                    <h3 className="text-center font-gilroy">
                        Electric Mobility Solutions For
                    </h3>
                </div>


                {/* Render 3 Rows */}
                <div className="relative flex flex-col md:flex-row items-center justify-center p-6">
                    {/* Desktop/Tablet Layout */}
                    <div className="hidden lg:block relative w-[900px] h-[600px]">
                        {/* Center Image */}
                        <img
                            src={chargerImage}
                            alt="EV Charger"
                            className="absolute top-1/2 left-1/2 h-full transform -translate-x-1/2 -translate-y-1/2 z-10"
                        />

                        {/* Top Left Card */}
                        <FeatureCard
                            number="1"
                            title="Built-in safety"
                            content={[
                                'Overcurrent',
                                'Overvoltage and undervoltage',
                                'Ground fault',
                                'Surge protection',
                            ]}
                            className="absolute top-10 left-0"
                        />

                        {/* Top Right Card */}
                        <FeatureCard
                            number="2"
                            title="Dynamic Load management"
                            content={[]}
                            className="absolute top-[150px] -right-20 w-[500px]"
                        />

                        {/* Bottom Left Card */}
                        <FeatureCard
                            number="3"
                            title="Connectivity"
                            content={['Ethernet RJ45', 'WiFi', 'GSM - 4G variants', 'OCPP 1.6']}
                            className="absolute bottom-20 left-0 w-[500px]"
                        />

                        {/* Bottom Right Card */}
                        <FeatureCard
                            number="4"
                            title="Connectors"
                            content={['Bharat AC', 'CSS2']}
                            className="absolute bottom-20 right-0"
                        />
                    </div>

                    {/* Mobile Layout */}
                    <div className="lg:hidden flex flex-col gap-4 w-full">
                        <FeatureCard
                            number="1"
                            title="Built-in safety"
                            content={[
                                'Overcurrent',
                                'Overvoltage and undervoltage',
                                'Ground fault',
                                'Surge protection',
                            ]}
                            className="!w-full"
                        />
                        <FeatureCard number="2" title="Dynamic Load management" content={[]} className="!w-full"/>
                        <FeatureCard
                            number="3"
                            title="Connectivity"
                            content={['Ethernet RJ45', 'WiFi', 'GSM - 4G variants', 'OCPP 1.6']}
                            className="!w-full"
                        />
                        <FeatureCard number="4" title="Connectors" content={['Bharat AC', 'CSS2']} className="!w-full"/>
                    </div>
                </div>


                {/* CTA Footer */}
                <div className="bg-gradient text-black rounded-xl px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-4">
                    <p className="text-xl lg:text-2xl font-semibold w-full xl:w-3/4 md:w-3/5 font-poppins">
                        Make your property EV-ready
                    </p>
                    <Button
                        title="Contact Us"
                        onClick={() => navigate('/get-in-touch')}
                    />
                </div>
            </div>
        </section>
    );
};


const FeatureCard = ({ title, content, number, className }) => (
    <div className={`bg-gray-100 p-4 rounded-lg shadow-md w-80 ${className}`}>
        <h3 className="font-semibold text-lg mb-2 flex justify-between items-center">                        
            <span className="text-2xl font-semibold font-gilroy">{title}</span>
            <span className="text-6xl font-bold text-gray-500 font-poppins">{number}</span>
        </h3>
        {content.length > 0 && (
            <ul className="list-disc pl-6 text-sm text-gray-700 space-y-1">
                {content.map((item, index) => (
                    <li key={index} className="text-gray-600 text-lg font-poppinss">{item}</li>
                ))}
            </ul>
        )}
    </div>
);

export default FourSteps;
